import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Cursed extends Modifier {
  static readonly baseTitle = 'Cursed';
  static readonly baseText = 'Resist an incoming Boon, then fade.';
  static readonly baseIcon = 'cursed';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Cursed.baseTitle;
  text = Cursed.baseText;
  icon = Cursed.baseIcon;
  tags: Array<ModifierTags> = [...Cursed.baseTags];
  priority = Cursed.basePriority;

  modifierAdd(type: StatusEffect, stacks: number) {
    const modifier = StatusEffectRegistry.create(type, this.owner, 0);
    if (modifier.tags.includes(ModifierTags.Boon)) {
      this.removeStacks(1); // This will automatically remove the modifier when stacks hit 0
      return 0;
    }
    return stacks;
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Cursed, Cursed);
